// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"b42b1708","703":"56966c0a","787":"a21a84eb"}[chunkId] + ".chunk.js";
};